import '@/styles/global.css'
import { Loading } from '@ui/loading'
import { Suspense } from 'react'
import ReactDom from 'react-dom/client'
import { ErrorBoundary } from '@/components/error-boundary'
import { i18n } from '@/i18n'
import { AppRouter } from '@/router/router'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDom.createRoot(rootEl)
  const tStart = performance.now()

  root.render(
    <ErrorBoundary>
      <Suspense fallback={<Loading message={i18n.t('common.loadingPage')} delayMs={300} size='lg' />}>
        <AppRouter />
      </Suspense>
    </ErrorBoundary>,
  )

  requestAnimationFrame(() => {
    const tEnd = performance.now()
    const ms = Math.round(tEnd - tStart)
    // 记录首屏渲染时间（近似）
    console.info(`[perf] 首屏渲染耗时 ~${ms}ms`)
  })
}
